import { getTenantFromToken } from "config/helpers/common_helper";
import { extractEhrInfoFromFhirBasic } from "config/helpers/extractEhrInfo_helper";
import { toast } from "react-toastify";
import { store } from "redux/store";
import {
  HTTPBridgeService,
  FHIRRead,
  FHIRSearch,
  HTTPLocalService,
} from "./http";
import dayjs from "dayjs";
import i18n from "multilingual";

// "x-connection-id": "1d862a71-3ff6-41d6-8fa8-fac329a57901",

const getConnectionId = () => {
  const data = store?.getState();
  const connectionId = data?.connectedEHR?.connectionId;
  if (!connectionId) {
    toast.error("No EHR Connection has been established");
    throw new Error("ConnectionId Not Found");
  }
  return connectionId;
};

export const CREATE_CONNECTION_TO_BRIDGE = async (data, setIsSyncActive) => {
  //Accepts data with the following fields: ehrName, connectionName, accountId, clientId, clientSecret
  //Sends data to the bridge to create a Connection ID, which is to be used with every subsequent call as x-connection-id
  try {
    const url = `/v1/ehr/connection/tenants/${getTenantFromToken()}`;
    const response = await HTTPBridgeService.post(url, {
      ...data,
      //! TODO Need to change to true once pushed to prod
      prodEnvironment: false,
    });
    const connectionId = response?.data?.connectionId;
    // Support both new and old formats for taskId
    const taskId =
      response?.data?.syncDetails?.taskId ||
      response?.data?.prioritySyncDetails?.taskId ||
      response?.data?.regularSyncDetails?.taskId;
    if (connectionId?.trim()) {
      toast.success("EHR Connection Successful");
    }
    return { connectionId, taskId };
  } catch (error) {
    if (error?.response?.data?.errorCode) {
      toast.error(i18n.t(`error_messages.${error?.response?.data?.errorCode}`));
    } else {
      toast.error(error?.response?.data?.message);
    }
    console.log(
      "An Error Occurred while trying to establish a connection to the bridge",
      error?.response?.data?.message
    );
  }
};

export const CREATE_ECW_BULK_CONNECTION = async (data) => {
  try {
    const url = `/api/tenants/${getTenantFromToken()}/connections/bulk/ecw`;
    if (data.clientSecret !== null) {
      //temporary fix for demo purpose
      data.clientSecret =
        "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDDzDzem05lrv2h\nM+lJqwnkXW1IsGG/iXiNm9QpQJpVZTxyJblkcReKUO1eJCZDJGKfe9LOqM66cIIf\nSGZOlPJCEm24ksP1C0oHTeIV0MOA71pdNukvUuuFW77i2dDZijd719SjpvmhaTKe\nTPBlm/stbcEL2RlYsba4AStUAtW/x6K+h73snh5aB9drwfF/yOZ9eguHhDRH8adH\n0TDCLuxBZMLKmHJUeAAxlZk4ryGKHn6akk74wCNhxnVL5hY2AyojBCg3oE83KfXt\n7xH2e3kjC5+iUin64nfCQ4ggNUzwpzBanwvC6wVVuqDyZ0Z9QJ3OYWdhR9sGblv1\nlTw1rQmjAgMBAAECggEAYacFXMj8qr5CBRpM6c8CWgE2tiAyQEMh+w6THBf6YUji\ngtPJyQyWfwepu2AwLSCCh6RMGYIbyOTAITYMwHiM8uMaEgow7ZA51bbEYbkDKNU3\nrnHqjw2+JX8Cj0WvYjALSBr3FL/8lMJQ2p7o7uSCu7+Xnn8ioxfPV6pNn9LiJIlf\nj5CtNZ/s9ZxQ30Om1FCozEg0P8SfX06/XQfrh32xn4X9ZNzI8KuKCwZVh7fR8LBv\nRz5To8owhYFSiMqucj6Q6levfMi4UoGDfZ+LBj/EI+tbrz0lzF+7zN51o1hJKJUb\nzOZ0hwEiIjTMZvF8F74zWjSqgoN+uVlH+fkIO0tlgQKBgQDhWHj3eqAQqaaFj5m+\nZlbpw5pziCGFOWUd6eBL9xI4ZvtuEfAUf+mVHJRqiyjmdTh2xzQtwCzV6J/rhtOO\nyImdhZcV9NGPrQdIwUx6OEzN6JfKkLF+bECLnnNQNV+A+keV88BFQX4NW7go/ZJc\naHJdIixk1yZGrePUCmbU3HzUwwKBgQDebsfje/4wm62Bs6Uy/XER6ZAkCScyqwCG\nVHA9QPXArDB+ebOteKqXtHaUxtO9a2CudsOYdLotwXEpfytQ1KWehxWOiXucEPVg\nKQY2RCbpevYpWm2ky0GyJXTATpncj0UEmuOWu+cb8l+2eWYQ/0fgZbfQ5/mwUMWL\nErGzDQgpoQKBgQDG9JvotCV6UK6rITv2dNirj31gH4Ko4yG5pXHY4A0AKzw11DSJ\nhN2wPwlyf+beggQWKo6RDikHu1jmU6WZXMjTgM0CH6KeHYBe5fsltWtqKL9LozBy\nlBTwsDbTTCxD7bUiWZEaFFa8aIxR9H8ygyzluXREnAg5QvHxljVwHjNAjQKBgQCJ\nlucojTtoH/RMxa4Lg4Bcvyg9Ujgf/G0fqr2e9j7OBvUcVvXQ+VI08xli4DZ79h7g\n7HADLzk3MnBoZdSKdG9aR18LQ3nlyQuvhtDj4nZbeIcqf1hRVrV1l/vHNRexuiHM\nPm9Hf0XvIJcaDbAYFYEFioYQwF3QNbZsV4z6H7aL4QKBgFf9YjwL0rCYmW3w9rA2\nxhBHPoD/zwnkZDWhSlFs35wnQboexbOfMlci1ugg0uc1wNIXmYM7HrGDUF/5x84f\nkzxvUwmgBi3U3EEtjOSWwfNyu/mYHux51izwpC3EPjhIwt/0QTAMEtAdb/WpbjWw\nLejcnV4sjFPRok+G5ENVgpQ4\n-----END PRIVATE KEY-----";
    }
    const response = await HTTPBridgeService.post(url, {
      ...data,
      //! TODO Need to change to true once pushed to prod
      prodEnvironment: false,
    });

    return response?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    console.log(
      "An Error Occurred while trying to establish a connection to the bridge",
      error?.response?.data?.message
    );
  }
};

export const CREATE_CONNECTION_TO_BRIDGE_WITH_SSO = async (data) => {
  //Accepts data with the following fields: ehrName, connectionName, accountId, clientId, clientSecret
  //Response will have a url where user is redirectd to authenticate themselves with SSO
  try {
    const url = `/api/tenants/${getTenantFromToken()}/connections/sso`;
    const response = await HTTPBridgeService.post(url, {
      ...data,
      //! TODO Need to change to true once pushed to prod
      prodEnvironment: false,
    });
    const SSOAuthUrl = response?.data?.url;
    window.open(SSOAuthUrl, "_self");
  } catch (error) {
    toast.error(error?.response?.data?.message);
    console.log(
      "An Error Occurred while trying to establish a connection to the bridge",
      error?.response?.data?.message
    );
  }
};

export const STORE_CONNECTION_DETAILS_IN_BASIC = async (
  connectionDetails,
  isSync = false
) => {
  const response1 = await HTTPBridgeService.post(
    `/api/tenants/${getTenantFromToken()}/connections/create`,
    connectionDetails
  );
  const extractedData = extractEhrInfoFromFhirBasic(response1?.data);
  const { connectionId, ehrName } = extractedData;
  //Sync EHR Patients into Noki with the given connectionId
  if (!isSync) {
    await SYNC_EHR_PATIENT(connectionId, ehrName);
  }
  toast.success("EHR Connection Successful");
  return { connectionId, ehrName };
};

export const CREATE_EHR_PATIENT = async (payload) => {
  try {
    const connectionId = getConnectionId();
    const response = await HTTPBridgeService.post(
      `/api/tenants/${getTenantFromToken()}/create/patient/${connectionId}`,
      payload,
      {
        headers: {
          "x-connection-id": connectionId,
        },
      }
    );

    return response;
  } catch (error) {
    console.log("An Error Occurred while creating patient", error.message);
  }
};

export const GET_EHR_PATIENT_BY_ID = async (id) => {
  //Accepts Patient ID fetches the given patient
  if (id === undefined) return;
  try {
    const connectionId = getConnectionId();

    const response = await HTTPBridgeService.get(`/api/patient/${id}`, {
      headers: {
        "x-connection-id": connectionId,
      },
    });

    return response?.data;
  } catch (error) {
    console.log("An Error occurred while fetching patients", error);
  }
};

export const GET_EXTERNAL_PRACTITIONER_ID = async (id) => {
  try {
    const connectionId = getConnectionId();
    const response = await HTTPBridgeService.get(
      `/api/tenants/${getTenantFromToken()}/encounter/${id}`,
      {
        headers: {
          "x-connection-id": connectionId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.log(
      "An Error occurred while fetching encounter information by encounterId"
    );
  }
};

export const SYNC_EHR_PATIENT = async (connectionId, ehrName, retryId = 0) => {
  //Syncs patient information from Bridge to Noki Fhir Store
  try {
    //const queryParam = ehrName === "NextGen" ? "?top=0" : "";
    let queryParam = "";
    console.log("ehrName:", ehrName);
    if (ehrName === "NextGen") {
      queryParam = "?top=0";
    } else if (ehrName === "Cerner") {
      const givenValue = "joe";
      queryParam = `?given=${givenValue}`;
    } else if (ehrName === "prognoCIS") {
      const first_name = "Brown";
      const last_name = "Elijah";
      queryParam = `?first_name=${first_name}&last_name=${last_name}`;
    }
    console.log("queryParam:", queryParam);
    const url = `/api/tenants/${getTenantFromToken()}/patient/sync/${connectionId}${queryParam}`;

    const response = await HTTPBridgeService.get(url, {
      headers: {
        "x-connection-id": connectionId,
      },
    });
    //Checking if the API has created the resources correctly, if not calling GET_EHR_PATIENT_BY_ID recurrsively on 500 ms intervals
    if (response?.data?.success) {
      return;
    } else if (
      response?.data?.message?.includes("Patient sync operation failed")
    ) {
      toast.error("An Error occurred while fetching patients from the EHR");
      return;
    } else if (response?.data?.fhirtask?.status === "failed" && retryId < 5) {
      //Need to add a fallback limit for recurrsively calling GET_PATIENT function in case api fails
      await new Promise((resolve) => setTimeout(resolve, 30000));
      await SYNC_EHR_PATIENT(connectionId, retryId + 1);
    } else {
      // toast.error(
      //   "An Error occurred while fetching patients from the EHR Maximum retries hit"
      // );
      return;
    }
  } catch (error) {
    console.log("An Error occurred while fetching patients from the EHR");
  }
};

export const GET_EHR_CONNECTION_STATUS = async () => {
  try {
    const url = `/v1/ehr/connection/tenants/${getTenantFromToken()}`;
    const response = await HTTPBridgeService.get(url);
    const data = response?.data;
    return data;
  } catch (error) {
    console.log("Error Occurred while Fetching EHR status", error);
  }
};

export const SYNC_EHR_ENCOUNTERS_WITH_PATIENTID = async (patientId) => {
  const connectionId = getConnectionId();
  try {
    if (!connectionId) throw new Error("ConnectionId is Invalid");
    if (!patientId) throw new Error("PatientId is Invalid");
    const url = `/api/tenants/${getTenantFromToken()}/create/encounter/${connectionId}`;
    // const {
    //   data: { entry: data },
    // } = await HTTPBridgeService.post(url, { patientId });
    // return data;
  } catch (error) {
    console.log("Error Occurred while Syncing Ecounters", error);
  }
};

export const SYNC_EHR_ENCOUNTER_RESOURCES_WITH_PATIENTID = async (
  patientId
) => {
  const connectionId = getConnectionId();
  try {
    if (!connectionId) throw new Error("ConnectionId is Invalid");
    if (!patientId) throw new Error("PatientId is Invalid");
    //const url = `/api/tenants/${getTenantFromToken()}/patient/create/clinicalnote/${connectionId}`;
    //create/encounter
    const url = `/api/tenants/${getTenantFromToken()}/create/encounter/${connectionId}`;
    const {
      data: { entry: data },
    } = await HTTPBridgeService.post(url, { patientId });
    console.log("data:", data);
    return data;
  } catch (error) {
    console.log("Error Occurred while Syncing Ecounters", error);
  }
};

export const PUSH_DOCUMENT_REFERENCE_WITH_ENCOUNTERID = async (encounterId) => {
  const connectionId = getConnectionId();

  if (!connectionId) throw new Error("ConnectionId is Invalid");
  if (!encounterId) throw new Error("EncounterId is Invalid");

  const url = `/api/tenants/${getTenantFromToken()}/create/documentreference/${connectionId}`;
  const data = await HTTPBridgeService.post(url, { encounterId });
  return data;
};

export const PUSH_SOAP_NOTE = async (observationId) => {
  if (!observationId) throw new Error("ObservationId is Invalid");

  const url = `/v1/ehr/upload/tenants/${getTenantFromToken()}/Observation/${observationId}`;
  const data = await HTTPBridgeService.post(url);
  return data;
};

export const SEARCH_PRACTITIONER_DATA = async ({
  firstName,
  lastName,
  dateOfBirth,
}) => {
  const connectionId = getConnectionId();
  const tenantId = getTenantFromToken();

  const params = new URLSearchParams();
  if (lastName) params.append("family", lastName);
  if (firstName) params.append("given", firstName);
  if (dateOfBirth) {
    const formattedDOB = dayjs(dateOfBirth).isValid()
      ? dayjs(dateOfBirth).format("YYYY-MM-DD")
      : null;

    if (formattedDOB) {
      params.append("birthdate", formattedDOB);
    } else {
      console.warn(
        "Invalid dateOfBirth passed to SEARCH_PRACTITIONER_DATA:",
        dateOfBirth
      );
    }
  }

  const url = `/api/tenants/${tenantId}/practitioner?${params.toString()}`;
  console.log("url:", url);
  const practitionerData = await HTTPBridgeService.get(url, {
    headers: {
      "x-connection-id": connectionId,
    },
  });

  return practitionerData?.data?.entry;
};

export const GET_FHIR_TASK = async (taskId) => {
  // Use FHIRSearch for direct FHIR Task fetch
  try {
    const response = await FHIRSearch("Task", `taskId=${taskId}`);
    return response?.data;
  } catch (error) {
    console.error("Failed to fetch FHIR Task:", error);

    // Return error information for better handling upstream
    if (error?.response?.status === 404) {
      // Task not found - likely completed or expired
      throw new Error("TASK_NOT_FOUND");
    } else if (
      error?.response?.status >= 400 &&
      error?.response?.status < 500
    ) {
      // Client errors (400-499)
      throw new Error(`CLIENT_ERROR_${error.response.status}`);
    } else if (error?.response?.status >= 500) {
      // Server errors (500+)
      throw new Error(`SERVER_ERROR_${error.response.status}`);
    }

    // Network or other errors
    throw error;
  }
};
